import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "compose__send",
  "use": "compose__send-usage",
  "viewBox": "0 0 20 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 18\" id=\"compose__send\">\n  <title>Send</title>\n  <path d=\"M18.831 9.9335 1.7103 17.271c-.5077.2175-1.0955-.0176-1.313-.5252a1 1 0 0 1-.0791-.4543l.3926-6.4889 6.9968.0002c.5004 0 .9135-.3745.974-.8586l.0077-.1231c0-.5422-.4395-.9818-.9817-.9818L.691 7.8397l-.52-5.9114C.1227 1.378.5295.8929 1.0797.8446a1 1 0 0 1 .4711.0727l17.2699 7.1736a1 1 0 0 1 .0103 1.8426Z\" fill-rule=\"evenodd\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol